'use strict';
const tabsWithContent = () => {
	let tabs = document.querySelectorAll('#tabbed-content .tabs li');
	if (tabs.length === 0) {
		return;
	}
	let tabsContent = document.querySelectorAll('.tab-content');

	let deactivateAllTabs = function () {
		tabs.forEach(function (tab) {
			tab.classList.remove('is-active');
		});
	};

	let hideTabsContent = function () {
		tabsContent.forEach(function (tabContent) {
			tabContent.classList.remove('is-active');
		});
	};

	let activateTabsContent = function (tab) {
		tabsContent[getIndex(tab)].classList.add('is-active');
	};

	let getIndex = function (el) {
		return [...el.parentElement.children].indexOf(el);
	};

	tabs.forEach(function (tab) {
		tab.addEventListener('click', function () {
			deactivateAllTabs();
			hideTabsContent();
			tab.classList.add('is-active');
			activateTabsContent(tab);
		});
	});

	tabs[0].click();
};

tabsWithContent();
